export default __webpack_public_path__ + "static/media/dialyysi-white.d807828a.svg";